import { getJson } from '../../../../shared/api/httpClient';

export function loginUser(query) {
  return getJson('UserLogin', query, {
    networkErrorMessage: 'Login request failed',
    resultErrorMessage: 'Login failed'
  });
}
